import axiosCore from 'axios';
import moment from 'moment-timezone';
declare const window: any;
const debug = process.env.NODE_ENV !== 'production';

export const BASE_URL = debug ? 'http://localhost:8080' : window.location.hostname.includes('planbookbeta.com')
  ? 'https://planbookbeta.com' : 'https://planbook.com';

const axios = axiosCore.create({
  baseURL: BASE_URL
});

axios.defaults.withCredentials = true;
axios.defaults.headers.common['X-PB-MOMENT-TZ'] = moment.tz.guess();

axios.interceptors.request.use(config => {
  const url = config.url;
  console.log('(API CALL) ' + url + ' ========== START');
  if (config.params) {
    console.log('REQUEST PARAMS: ' + JSON.stringify(config.params));
  }
  if (config.headers) {
    config.headers.Authorization = getAuthBearerToken();
  }
  (config as any).metadata = { start: Date.now() }
  if (config.data) {
    console.log('REQUEST DATA: ' + JSON.stringify(config.data));
  }
  return config;
}, error => {
  return Promise.reject(error);
});

function getAuthBearerToken() {
  return 'Bearer ' + (sessionStorage.token || '');
}

export default axios;
